import { slider, slideritem } from 'vue-concise-slider'
import cheader from '@/components/header/index.vue'
import { mounted } from 'vue-echarts'

export default {
	name: 'index',
	data() {
		return {
            serverUrl: this.$store.state.config.serverUrl,
			banners: [],
			goods: [],
			suppliers: [],
			options: {
				currentPage: 0,
				thresholdDistance: 0,
				thresholdTime: 100,
				autoplay: true,
				loop: true,
				direction: 'horizontal',
				loopedSlides: 0,
				slidesToScroll: 0,
				timingFunction: 'ease',
				speed: 300,
				infinite: 0,
			},
			hots: [],
			orders: []
		}
	},
	computed: {
		user() {
			return this.$store.state.user
		}
	},
	mounted() {
		// console.log(this.$store.state.user.type,'角色');
		// console.log(this.$store.state.user.vipEndDate,'到期时间');
	},
	components: {
		cheader,
		slider,
		slideritem
	},
	created() {
		this.bannerIndex()
		this.optimalIndex()
		this.supplierIndex()
		this.hotIndex()
		this.orderIndex()
		// this.getInfo()
	},
	methods: {
    slide (data) {},
    onTap (data) {},
    onInit (data) {},
		go(url) {
			this.$router.push(url)
		},
		// 获取banner
		bannerIndex() {
			this.$http.get('/api/banner').then((res) => {
				this.banners = res.data.data
			})
		},
		// 获取优选商品
		optimalIndex() {
			this.$http.get('/api/optimal').then((res) => {
				this.goods = res.data.data.splice(0,8)
			})
		},
		// 获取优选供应商
		supplierIndex() {
			this.$http.get('/api/supplier').then((res) => {
				this.suppliers = res.data.data
			})
		},
		// 获取热门询价
		hotIndex() {
			this.$http.get('/api/hot', {params: {userId: this.user.id}}).then((res) => {
				this.hots = res.data.data
			})
		},
		getInfo() {
			this.$http.get('/api/user/getInfo', { params: { userId: this.user.id } }).then((res) => {
				localStorage.setItem('userStatus', JSON.stringify(res.data.data.status))
				localStorage.setItem("vipEndDate", res.data.data.vipEndDate);
				console.log(localStorage.getItem('userStatus'));
				// localStorage.setItem('userDate', JSON.stringify(res.data.data.vipEndDate))
				// console.log(localStorage.getItem('userDate'));
				// console.log(this.queryYear());
				// setTimeout(() => {
				// 	const date1 = new Date(localStorage.getItem('userDate'));
				// 	const date2 = new Date(this.queryYear());
				// 	let date3 = this.daysBetween(date1, date2);
				// 	console.log(date3);
				// 	localStorage.setItem("timerId", date3)
				// }, 200);
			})
		},
		daysBetween(date1, date2) {
			const oneDay = 24 * 60 * 60 * 1000; // 每天的毫秒数
			const firstTime = date1.getTime(); // 第一个时间的毫秒数
			const secondTime = date2.getTime(); // 第二个时间的毫秒数
			return Math.round((secondTime - firstTime) / oneDay);
		},
		queryYear() {
			var date = new Date();
			var year = date.getFullYear();  // 年份
			var month = date.getMonth() + 1;  // 月份，返回值为0-11，所以需要加1
			var day = date.getDate();  // 日期
			// 对月份和日期进行补零
			month = month < 10 ? '0' + month : month.toString();
			day = day < 10 ? '0' + day : day.toString();
			var currentDate = year + '-' + month + '-' + day;
			return currentDate
		},
		// 获取我的报价或者询价
		orderIndex() {
			if(this.user) {
				let url = this.user.type == '采购商' || this.user.types == '5' ? '/api/myinquiry' : '/api/myquate'
				this.$http.get(url, {params: {userId: this.user.id}}).then((res) => {
					this.orders = res.data.data
				})
			}
		}
	}
}







// WEBPACK FOOTER //
// ./src/views/home/index/index.js